const players = [];

const player = function( node, settings = {} ) {
	const config = Object.assign( {
		videoWidth: '100%',
		videoHeight: '100%',
		stretching: 'responsive',
		showPosterWhenEnded: false,
	}, settings );

	config.success = function( media, node, instance ) {
		media.addEventListener( 'play', () => {
			instance.container.classList.add( 'gfi-mediaelement--active' );
			instance.container.classList.remove( 'gfi-mediaelement--paused' );
		} );
		media.addEventListener( 'ended', () => {
			instance.container.classList.remove( 'gfi-mediaelement--active' );
			instance.container.classList.remove( 'gfi-mediaelement--paused' );
		} );
		media.addEventListener( 'pause', () => {
			instance.container.classList.add( 'gfi-mediaelement--paused' );
		} );

		if ( typeof settings.success === 'function' ) {
			settings.success( media, node, instance );
		}
	}

	const instance = new MediaElementPlayer( node, config );

	players.push( instance );

	return instance;
}

document.addEventListener( 'DOMContentLoaded', function() {
	Array.from( document.querySelectorAll( '.gfi-mediaelement' ) ).forEach( video => player( video ) );
} );

export default {
	player,
	players,
}
